import React, { Component } from 'react';

class ApplyPriceAdjustmentHoldDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false
    };
  }

  componentDidMount() {
    this.setState({
      showDialog: this.props.showDialog
    });
  }

  closeDialog(event) {
    event.preventDefault();
    this.setState({
      showDialog: false
    });
    this.props.handleDialog('PriceAdjustmentHoldDialog');
  }

  handleApply(event) {
    event.preventDefault();
    this.props.onApply();
  }

  render() {
    return (
      <div className={"overlayDialog " + (this.state.showDialog ? "visible" : "hide")} id="applyPriceAdjustmentHoldDialog">
        <div className="blackoutLayer"></div>

        <div className="overlayDialogWindow">
          <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>

          <h2 className="title">Apply Price Adjustment Hold</h2>

          <p>
            This will apply a Price Disputes Hold to this order which delays shipping until the price adjustment is complete.
          </p>

          <p>
            To request a price adjustment, the ASM should go to Manage Orders once the order has booked and select Request Price Adjustment to go to the Price Adjustment form.
          </p>

          <p className="bold">
            Click APPLY HOLD and then proceed to BOOK the order.
          </p>

          <div className="noButtonContainer">
            <a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>
              Cancel
            </a>
          </div>

          <div className="yesButtonContainer">
            <a className="yesButton blueButton" onClick={this.handleApply.bind(this)}>
              Apply Hold
            </a>
          </div>

        </div>
      </div>
    );
  }
}

export default ApplyPriceAdjustmentHoldDialog;


// WEBPACK FOOTER //
// ./src/App/components/dialogs/applyPriceAdjustmentHoldDialog.js